import React, { useCallback } from "react";
import chevronIcon from "../assets/chevron-right.svg";
import "../styles/gateway/number-input.css";

/**
 * Number input with up/down chevron buttons.
 * Accepts all props that a normal <input> would, plus `step`.
 */
export default function NumberInput({ value, onChange, step = 1, min, max, className = "", disabled = false, ...props }) {
  const numValue = parseFloat(value) || 0;

  const nudge = useCallback((dir) => {
    let next = numValue + dir * step;
    if (min !== undefined && next < min) next = min;
    if (max !== undefined && next > max) next = max;
    if (onChange) {
      onChange({ target: { value: String(next) } });
    }
  }, [numValue, step, min, max, onChange]);

  return (
    <div className="gwNumberWrap">
      <input
        {...props}
        type="number"
        step="any"
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`gwInput gwNumberInput ${className}`}
      />
      <div className="gwNumberButtons">
        <button
          type="button"
          className="gwNumberBtn"
          aria-label="Increase"
          tabIndex={-1}
          disabled={disabled}
          onMouseDown={(e) => { e.preventDefault(); nudge(1); }}
        >
          <img src={chevronIcon} alt="" className="gwNumberChevron up" />
        </button>
        <button
          type="button"
          className="gwNumberBtn"
          aria-label="Decrease"
          tabIndex={-1}
          disabled={disabled}
          onMouseDown={(e) => { e.preventDefault(); nudge(-1); }}
        >
          <img src={chevronIcon} alt="" className="gwNumberChevron down" />
        </button>
      </div>
    </div>
  );
}
